import { Component } from '@angular/core';
import { Contractor } from '@authority-labs/api-interfaces';
import { nameof } from '@authority-labs/helpers';
import { ContractorsService } from '../contractors.service';

@Component({
  selector: 'authority-labs-select-planner-dialog',
  templateUrl: './select-contractor-dialog.component.html',
  styleUrls: ['./select-contractor-dialog.component.scss']
})
export class SelectContractorDialogComponent {
  title = 'קבלן';
  searchFields = [
    nameof<Contractor>('id'),
    nameof<Contractor>('name'),
    nameof<Contractor>('jobTitle'),
    nameof<Contractor>('email'),
    nameof<Contractor>('phone'),
    nameof<Contractor>('address'),
    nameof<Contractor>('companyNumber')
  ];

  getLabel(contractor: Contractor): string {
    return contractor ? contractor.name : '';
  }

  constructor(public service: ContractorsService) {}
}
